/* global axios */
import ApiClient from './ApiClient';

// Conversation scoped AI suggestion endpoints, keyed by conversation display id.
class ConversationAiSuggestionsAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  suggestionsUrl(conversationId) {
    return `${this.url}/${conversationId}/ai_suggestions`;
  }

  get(conversationId) {
    return axios.get(this.suggestionsUrl(conversationId));
  }

  // `channelType`: the channel the nurse's reply box has selected. The server
  // decides whether a draft can go out there (ai-docs/ai-suggestions.md
  // "Channels"); without it, it assumes the conversation's default channel.
  create(conversationId, { channelType } = {}) {
    return axios.post(
      this.suggestionsUrl(conversationId),
      channelType ? { channel_type: channelType } : undefined
    );
  }

  apply(conversationId, id, { text, channelType }) {
    return axios.post(`${this.suggestionsUrl(conversationId)}/${id}/apply`, {
      text,
      ...(channelType ? { channel_type: channelType } : {}),
    });
  }

  // Not useful is one click; a reason can follow through setReason.
  reject(conversationId, id) {
    return axios.post(`${this.suggestionsUrl(conversationId)}/${id}/reject`);
  }

  // Only on a row this user rejected; a blank reason clears it.
  setReason(conversationId, id, { reason }) {
    return axios.patch(`${this.suggestionsUrl(conversationId)}/${id}/reason`, {
      reason,
    });
  }

  dismiss(conversationId, id) {
    return axios.post(`${this.suggestionsUrl(conversationId)}/${id}/dismiss`);
  }

  ratingUrl(conversationId) {
    return `${this.url}/${conversationId}/ai_rating`;
  }

  // `{ eligible, rating, question }` for the current user.
  getRating(conversationId) {
    return axios.get(this.ratingUrl(conversationId));
  }

  // `{ helpful, note?, tags? }`, or `{ skipped: true }`.
  saveRating(conversationId, payload) {
    return axios.post(this.ratingUrl(conversationId), payload);
  }
}

export default new ConversationAiSuggestionsAPI();
